<template>
  <el-form :inline="true"
    :model="formInline"
    class="demo-form-inline">
    <el-form-item label="计划名称">
      <el-input v-model="formInline.name"
        placeholder="请输入计划名称"
        clearable></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
        @click="submitBtn">查询</el-button>
    </el-form-item>
    <el-form-item>
      <el-button type="warning"
        icon="el-icon-plus"
        v-if="judgeAuthority('houqinguanli:xunjianguanli:patrolPlan:edit')"
        @click="handleAdd">新增巡检计划</el-button>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" plain
        v-if="judgeAuthority('houqinguanli:xunjianguanli:patrolPlan:export')"
        @click="$parent.exportExcel()"><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
export default {
  data() {
    return {
      formInline: {
        name: "",
      },
    };
  },
  methods: {
    judgeAuthority,
    submitBtn() {
      this.$emit("getFormBtn", {
        searchTxt: this.formInline.name,
        planId: "",
      });
    },
    handleAdd() {
      this.$emit("handleAddEdit", {});
    },
  },
  created() {
    this.formInline.name = this.$route.query.name ?? "";
    this.$emit("getFormBtn", {
      searchTxt: this.formInline.name,
      planId: this.$route.query.id ?? "",
    });
  },
};
</script>

<style>
</style>